// @ts-nocheck
import useSWR from 'swr';

import { fetchModels } from 'src/store/api';

async function fetchModelsWithConfig(q, o, { includeRefresh }) {
  const models = await fetchModels(q, o);

  if (includeRefresh) {
    // Not needed anymore
  }

  return models;
}

const defaultConfig = {
  shouldFetch: true,
  revalidateIfStale: false,
  revalidateOnMount: false,
  revalidateOnFocus: false,
};

export default function useModels({ query, options = {}, config = {} }) {
  const { shouldFetch, ...swrConfig } = { ...defaultConfig, ...config };

  const url = `/core/v2/thinkalike_model?query=${JSON.stringify(query)}&config=${JSON.stringify(config)}`;
  const { fields = '*', ...requestQuery } = query;
  const requestOptions = {
    headers: {
      'X-Fields': fields,
    },
    ...options,
  };

  return useSWR(
    shouldFetch ? { key: url, requestQuery, requestOptions } : null,
    ({ requestQuery: q, requestOptions: o }) => fetchModelsWithConfig(q, o, config),
    swrConfig
  );
}
